//** Import Modules */
import React, { useEffect, useState } from "react";
import ContentPageTitle from "../../../../common/ContentPageTitle";
import { Route, Routes } from "react-router-dom";
import { useManagementBusinessType } from "../../../../hooks/useManagementBusinessType";
import CategoriesSettings from "./BusinessTypeSettings";
import axiosWithAuth from "../../../../utils/axiosWithAuth";

export default function BusinessTypeManagement(props) {
  const { user } = props;

  //* Get Categories
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllCategories();
  }, []);

  const getAllCategories = () => {
    const APIURL = `/api/business/categories/list`;

    axiosWithAuth()
      .get(APIURL)
      .then((res) => {
        const categoriesList = res.data.map((category) => {
          return {
            ...category,
            key: category.id,
          };
        });

        setCategories(categoriesList);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  //* Prepare Hook
  const hookData = {
    creatorID: user.id,
    setState: setCategories,
    itemType: "category",
    dispatchAction: getAllCategories,
    deleteItemAPI: "/api/business/category",
    modalData: {
      title: "Create New Business Type",
      fieldLabel: "Business Type Name",
    },
  };

  const [modalComponent, CreateItemButton, ListComponent] =
    useManagementBusinessType(hookData);

  return (
    <div>
      <ContentPageTitle title="Business Type Management" icon="list" />

      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ListComponent
                  emptyMessage="Seems like you don't have any categories."
                  btnText="Create New category"
                  listItems={categories}
                />

                <CreateItemButton btnText="Create New Business Type" />
              </>
            }
            exact
          />

          <Route path="/:id" element={<CategoriesSettings />} exact />
        </Routes>
      </div>

      {modalComponent}
    </div>
  );
}
